import {CHART_WIDGET_LINES_SET} from './actions'

const initialState = {
	tradeLines: ''
}

export default (state = initialState, action) => {
	switch (action.type) {
	case CHART_WIDGET_LINES_SET: {
		return {
			...state,
			tradeLines: action.payload
		}
	}
	default: {
		return state
	}
	}
}
